/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const Container = styled.div`
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .page-header {
    padding: 0 32px;
  }

  .btn-back {
    margin-top: 20px;
  }

  .page-title {
    margin-bottom: 10px;
  }

  .page-form {
    padding: 24px 32px;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    min-height: calc(100vh - 210px);
  }

  .left-side {
    flex-basis: 49%;
    display: flex;
    flex-direction: column;
  }

  .right-side {
    flex-basis: 49%;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }

  .right-side .ant-spin-nested-loading {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .right-side .ant-spin-container {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .right-side .ant-card {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .right-side .ant-card-body {
    flex: 1;
    overflow: auto;
  }

  .full-height {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .full-height .ant-card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .empty-box {
    margin-top: 100px;
  }
`;
